export const formatThousands = (value: number, unit = '') => {
	if (value === undefined || value === null) {
		return '';
	}
	return `${value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1 `)}${unit && ` ${unit}`}`;
};
